import { translations } from "./registry";
import { useLanguage } from "../hooks/LanguageProvider";

function getValue(obj: any, path: string): any {
    return path.split(".").reduce((acc, key) => acc?.[key], obj) ?? path;
}

export function useI18n() {
    const { language } = useLanguage();
    const t = (key: string) => getValue(translations[language], key);
    return { t };
}
